import React, { useState, useEffect } from 'react';
import { biolinkPlanList } from '../../redux/slice/BioLinkPlan';
import userlogo from '../../assets/images/1 Logo AD1.png';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import '../../assets/css/BioLink.css';
import { MdDashboard } from 'react-icons/md';
import { FaGlobe, FaLink, FaUserCheck } from 'react-icons/fa';

export default function BioLink() {
    const [activeBlock, setActiveBlock] = useState(0);
    const dispatch = useDispatch();
    const [isVisible, setIsVisible] = useState(false);
    const data = useSelector((state) => state?.biolinkPlanList?.data?.[0]);
    const navigate = useNavigate()
    console.log(data)

    useEffect(() => {
        setIsVisible(true);
        const interval = setInterval(() => {
            setActiveBlock((prev) => (prev + 1) % 7);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        dispatch(biolinkPlanList({ plan_type: 'biolink', navigate }))
    }, [])

    const handleBuyPlan = () => {
        navigate('/signup');
    }

    const blocks = [
        { icon: '👤', name: 'Avatar', color: '#667eea' },
        { icon: 'H', name: 'John Doe', color: '#764ba2' },
        { icon: '●', name: 'Paragraph', color: '#f093fb' },
        { icon: '⚠️', name: 'Alert', color: '#4facfe' },
        { icon: '📎', name: 'Example link', color: '#43e97b' },
        { icon: '✉️', name: 'Newsletter', color: '#fa709a' },
        { icon: '👥', name: 'Socials', color: '#fee140' }
    ];

    return (
        <div className="biolink-section">
            <div className="biolink-container">
                <div className="biolink-layout">

                    {/* Left Content */}
                    <div className={`biolink-content ${isVisible ? 'biolink-visible' : 'biolink-hidden'}`}>
                        <div className="biolink-badge" style={{ display: 'flex', width: 'fit-content', margin: '0 auto' }}>
                          <svg className="biolink-badge-icon" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm1 15h-2v-2h2zm0-4h-2V7h2z" />
                          </svg>
                            <span className="biolink-badge-text">Free Free Free</span>
                        </div>

                        <h1 className="biolink-title">
                            Your <span className="biolink-title-gradient">digital page</span> for everything
                        </h1>

                        <p className="biolink-description">
                            Create a stunning digital page that showcases your entire digital presence. Customizable, powerful, and built for creators.
                        </p>

                        <div className="biolink-features-grid">
                            {/* Fully Customizable */}
                            <div className="biolink-feature-card">
                                <svg className="biolink-feature-icon purple" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 3a9 9 0 0 0-9 9c0 3.9 2.51 7.24 6 8.47V21h6v-.53A9 9 0 0 0 12 3zm0 2a7 7 0 0 1 7 7c0 2.8-1.64 5.28-4.06 6.39L12 19l-2.94-1.61A7 7 0 0 1 5 12a7 7 0 0 1 7-7z" />
                                </svg>
                                <h3 className="biolink-feature-title">Fully Customizable Bio Page</h3>
                                <p className="biolink-feature-desc">Personalize colors, fonts, and layouts to match your brand.</p>
                            </div>

                            {/* Unique QR */}
                            <div className="biolink-feature-card">
                                <svg className="biolink-feature-icon blue" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M3 3h6v6H3V3zm2 2v2h2V5H5zm10-2h6v6h-6V3zm2 2v2h2V5h-2zM3 15h6v6H3v-6zm2 2v2h2v-2H5zm10-2h2v2h-2v-2zm4 0h2v2h-2v-2zm-4 4h2v2h-2v-2zm4 0h2v4h-6v-2h4v-2z" />
                                </svg>
                                <h3 className="biolink-feature-title">Unique QR</h3>
                                <p className="biolink-feature-desc">Get your own scannable QR code for easy sharing.</p>
                            </div>

                            {/* Privacy First */}
                            <div className="biolink-feature-card">
                                <svg className="biolink-feature-icon green" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                                </svg>
                                <h3 className="biolink-feature-title">Trusted Short Link</h3>
                                <p className="biolink-feature-desc">Trusted shareable short link which is safe for others.</p>
                            </div>

                            {/* Real Time Analytics */}
                            <div className="biolink-feature-card">
                                <svg className="biolink-feature-icon orange" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M3 3v18h18v-2H5V3H3zm16 10l-4-4-3 3-2-2-5 5v2h14v-4z" />
                                </svg>
                                <h3 className="biolink-feature-title">Real Time Analytics</h3>
                                <p className="biolink-feature-desc">Track every visit and each click related to your link.</p>
                            </div>
                        </div>


                        {/* <button className="biolink-cta-button">
              Get Started Free
              <svg className="biolink-cta-icon" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"/>
              </svg>
            </button> */}
                    </div>

                    {/* Right Preview */}
                    <div className={`biolink-preview ${isVisible ? 'biolink-visible' : 'biolink-hidden'}`}>

                        {/* Floating Elements */}
                        <div className="biolink-floating-element purple"></div>
                        <div className="biolink-floating-element blue"></div>

                        <div className="biolink-preview-container">

                            {/* Editor Panel */}
                            {/* <div className="biolink-editor">
                <div className="biolink-editor-header">
                  <div className="biolink-editor-dots">
                    <div className="biolink-dot red"></div>
                    <div className="biolink-dot yellow"></div>
                    <div className="biolink-dot green"></div>
                  </div>
                  <span className="biolink-editor-title">Editor</span>
                </div>

                <div className="biolink-editor-tabs">
                  <button className="biolink-tab inactive">Settings</button>
                  <button className="biolink-tab active">Blocks</button>
                </div>

                <div className="biolink-blocks-container">
                  {blocks.map((block, index) => (
                    <div
                      key={index}
                      className={`biolink-block-item ${activeBlock === index ? 'active' : ''}`}
                    >
                      <div className="biolink-drag-handle">⋮⋮</div>
                      <div className={`biolink-block-icon ${activeBlock === index ? 'active' : ''}`}>
                        {block.icon}
                      </div>
                      <span className={`biolink-block-name ${activeBlock === index ? 'active' : ''}`}>
                        {block.name}
                      </span>
                      <div className={`biolink-toggle ${activeBlock === index ? 'active' : ''}`}>
                        <div className={`biolink-toggle-dot ${activeBlock === index ? 'active' : ''}`}></div>
                      </div>
                    </div>
                  ))}
                </div>

                <button className="biolink-add-button">
                  + Add Block
                </button>
              </div> */}

                            {/* Mobile Preview */}
                            <div className="biolink-mobile-container">
                                <div className="biolink-mobile-frame">
                                    <div className="biolink-mobile-screen">

                                        {/* Notch */}
                                        <div className="biolink-mobile-notch"></div>

                                        <div className="biolink-mobile-content">
                                            {/* Unique Glassmorphic Card */}
                                            <div className="unique-card">
                                                <div className="unique-card-content text-center">
                                                    <div className="unique-profile-header">
                                                        <div className="unique-profile-img">
                                                            <img src={userlogo} alt="profile" />
                                                        </div>
                                                        <h5 className="unique-profile-name">AD1</h5>
                                                    </div>
                                                    {/* <hr className="profile-divider" /> */}

                                                    <div className="unique-card-list">
                                                        <div className="unique-card-item">
                                                            <MdDashboard className="unique-item-icon" />
                                                            <span>Dashboard</span>
                                                        </div>
                                                        <div className="unique-card-item">
                                                            <FaGlobe className="unique-item-icon" />
                                                            <span>Bio Page</span>
                                                        </div>
                                                        <div className="unique-card-item">
                                                            <FaLink className="unique-item-icon" />
                                                            <span>Short Links</span>
                                                        </div>
                                                        <div className="unique-card-item">
                                                            <FaUserCheck className="unique-item-icon" />
                                                            <span>Connection</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <button className="unique-buy-btn mt-3" onClick={handleBuyPlan}>
                                                    Get Started Now
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M5 12h14M12 5l7 7-7 7" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Floating Stats */}
                                {/* <div className="biolink-stats-card">
                                    <div className="biolink-stats-number">Subscription</div>
                                    <div className="biolink-stats-number">Plan</div>
                                </div> */}
                            </div>

                            {/* Second Mobile Preview - Bio Link Page */}
                            <div className="biolink-mobile-container biolink-mobile-second">
                                <div className="biolink-mobile-frame biolink-frame-second">
                                    <div className="biolink-mobile-screen biolink-screen-second">

                                        {/* Notch */}
                                        <div className="biolink-mobile-notch"></div>

                                        <div className="biolink-mobile-content biolink-content-second">
                                            {/* Plan Details directly on screen */}
                                            <div className="biolink-screen-plan">
                                                <div className="biolink-screen-plan-title">
                                                    Bio Page Subscription Plan
                                                </div>
                                                <div className="biolink-screen-plan-header">
                                                    <h3 className="biolink-screen-plan-name">{data?.name}</h3>
                                                </div>

                                                <div className="biolink-screen-plan-details">
                                                    <div className="biolink-screen-plan-row">
                                                        <span className="biolink-screen-plan-label">Price:</span>
                                                        <div className="biolink-screen-plan-price">
                                                            <div className="biolink-screen-plan-price-line">
                                                                {data?.mrp && parseFloat(data.mrp) > 0 && parseFloat(data.price) < parseFloat(data.mrp) && (
                                                                    <span className="biolink-screen-plan-mrp">₹{data?.mrp}</span>
                                                                )}
                                                                <span className="biolink-screen-plan-amount">
                                                                    {(() => {
                                                                        const [intPart, decPart] = String(data?.price ?? '').split('.');
                                                                        return (
                                                                            <>
                                                                                ₹{intPart}
                                                                                {decPart ? <span className="biolink-price-dec">.{decPart}</span> : null}
                                                                                <span className="biolink-price-currency"> INR</span>
                                                                            </>
                                                                        );
                                                                    })()}
                                                                </span>
                                                            </div>
                                                            {(parseFloat(data?.price_usd) > 0 || parseFloat(data?.mrp_usd) > 0) && (
                                                                <div className="biolink-screen-plan-price-line">
                                                                    {data?.mrp_usd && parseFloat(data?.mrp_usd) > 0 && parseFloat(data?.price_usd) < parseFloat(data?.mrp_usd) && (
                                                                        <span className="biolink-screen-plan-mrp">${data?.mrp_usd}</span>
                                                                    )}
                                                                    <span className="biolink-screen-plan-amount">
                                                                        {(() => {
                                                                            const [intPart, decPart] = String(data?.price_usd ?? '').split('.');
                                                                            return (
                                                                                <>
                                                                                    ${intPart}
                                                                                    {decPart ? <span className="biolink-price-dec">.{decPart}</span> : null}
                                                                                    <span className="biolink-price-currency"> USD</span>
                                                                                </>
                                                                            );
                                                                        })()}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="biolink-screen-plan-divider"></div>

                                                    <div className="biolink-screen-plan-row">
                                                        <span className="biolink-screen-plan-label">Description:</span>
                                                        <span className="biolink-screen-plan-value">{data?.description}</span>
                                                    </div>

                                                    <div className="biolink-screen-plan-divider"></div>

                                                    <div className="biolink-screen-plan-row">
                                                        <span className="biolink-screen-plan-label">Days Validity:</span>
                                                        <span className="biolink-screen-plan-value biolink-screen-plan-highlight">365 days</span>
                                                    </div>
                                                </div>

                                                <button className="biolink-screen-plan-btn" onClick={handleBuyPlan}>
                                                    Buy Plan
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}